
import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputSelect from '../../commons/form/InputSelect'
import InputCheckBox from '../../commons/form/InputCheckBox'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'
import { handleKeyDown } from '../../../util/utils'

class DocumentTypeUseMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  handleOnlyTemplateUploadChange (value) {
    this.props.actions.setDocumentDocumentOnlyTemplateUpload(value)
    this.props.change('canBePrinted', value)
  }

  submitDocument (values) {
    let languages = []
    Object.keys(values).map(item => {
      if (!!values[item] && typeof values[item] === 'object') {
        languages.push(values[item])
      }
    })
    if (languages && values.code && values.documentTypeId) {
      const documentTypeUse = {
        documentTypeUseId: values.documentTypeUseId,
        code: values.code,
        externalCode: values.externalCode,
        iconUrl: values.iconUrl,
        documentTypeId: values.documentTypeId,
        dependentDocumentTypeUseId: values.dependentDocumentTypeUseId,
        canCreateEntity: values.canCreateEntity,
        canBePrinted: values.canBePrinted,
        canBeAddedInHistorical: values.canBeAddedInHistorical,
        canSendToProcessingAgency: values.canSendToProcessingAgency,
        massiveUploadAllowed: values.massiveUploadAllowed,
        showInDocumentaryChecklist: values.showInDocumentaryChecklist,
        permissionId: values.permissionId,
        permissionEditId: values.permissionEditId,
        permissionViewId: values.permissionViewId,
        permissionRejectId: values.permissionRejectId,
        permissionSignId: values.permissionSignId,
        functionToDoWhenCreate: values.functionToDoWhenCreate,
        functionToDoWhenUpdate: values.functionToDoWhenUpdate,
        dependantFunctionToDoWhenCreate: values.dependantFunctionToDoWhenCreate,
        metadataTemplateCode: values.metadataTemplateCode,
        onlyTemplateUpload: values.onlyTemplateUpload,
        documentTypeUseLocales: languages,
        newVersionPermissionId: values.newVersionPermissionId
      }

      let hasChanges = false

      if (this.props.documentTypeUse &&
        (values.code !== this.props.documentTypeUse.code ||
          values.externalCode !== this.props.documentTypeUse.externalCode ||
          values.iconUrl !== this.props.documentTypeUse.iconUrl ||
          values.documentTypeId !== this.props.documentTypeUse.documentTypeId ||
          values.dependentDocumentTypeUseId !== this.props.documentTypeUse.dependentDocumentTypeUseId ||
          values.canCreateEntity !== this.props.documentTypeUse.canCreateEntity ||
          values.canBePrinted !== this.props.documentTypeUse.canBePrinted ||
          values.canBeAddedInHistorical !== this.props.documentTypeUse.canBeAddedInHistorical ||
          values.canSendToProcessingAgency !== this.props.documentTypeUse.canSendToProcessingAgency ||
          values.massiveUploadAllowed !== this.props.documentTypeUse.massiveUploadAllowed ||
          values.showInDocumentaryChecklist !== this.props.documentTypeUse.showInDocumentaryChecklist ||
          values.permissionId !== this.props.documentTypeUse.permissionId ||
          values.permissionEditId !== this.props.documentTypeUse.permissionEditId ||
          values.permissionViewId !== this.props.documentTypeUse.permissionViewId ||
          values.permissionRejectId !== this.props.documentTypeUse.permissionRejectId ||
          values.permissionSignId !== this.props.documentTypeUse.permissionSignId ||
          values.functionToDoWhenCreate !== this.props.documentTypeUse.functionToDoWhenCreate ||
          values.functionToDoWhenUpdate !== this.props.documentTypeUse.functionToDoWhenUpdate ||
          values.dependantFunctionToDoWhenCreate !== this.props.documentTypeUse.dependantFunctionToDoWhenCreate ||
          values.metadataTemplateCode !== this.props.documentTypeUse.metadataTemplateCode ||
          values.onlyTemplateUpload !== this.props.documentTypeUse.onlyTemplateUpload ||
          values.newVersionPermissionId !== this.props.documentTypeUse.newVersionPermissionId

        )) {
        hasChanges = true
      }

      this.props.actions.submitDocumentTypeUse(documentTypeUse, hasChanges)
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.documentTypeUse)
      this.props.languageList.map((language) => {
        this.props.change(`lang${language.languageId}.languageId`, language.languageId)
        const source = (this.props.documentTypeUse?.documentTypeUseId) ? this.props.documentTypeUse.documentTypeUseLocales.find((sourceChannel) => sourceChannel.languageId === language.languageId) : ''
        this.props.change(`lang${language.languageId}.name`, source ? source.name : '')
        this.props.change(`lang${language.languageId}.description`, source ? source.description : '')
      })
    }
  }

  render () {
    const {
      t, handleSubmit, languageList,
      showModal, documentTypeUse,
      combos: { documentType, permissionCombo, documentTypeUseCombo }
    } = this.props
    const tKey = 'MASTERS.DOCUMENT_TYPE_USE_MASTERS.MODAL.'
    return (
      <Modal id="documentTypeUseMasterModal" className="_nf" show={showModal} onHide={this.props.actions.closeDocumentTypeUseMasterModal} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitDocument.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeDocumentTypeUseMasterModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='search-form'>

              {documentTypeUse?.documentTypeUseId && (
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  name="documentTypeUseId"
                  controlLabel={t(`${tKey}ID`)}
                  placeholder={t(`${tKey}ID`)}
                  disabled={true}
                />
              )}

              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="code"
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                maxLength={30}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="externalCode"
                controlLabel={t(`${tKey}EXTERNAL_CODE`)}
                placeholder={t(`${tKey}EXTERNAL_CODE`)}
                maxLength={30}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="iconUrl"
                controlLabel={t(`${tKey}URL`)}
                placeholder={t(`${tKey}URL`)}
                maxLength={50}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="documentTypeId"
                controlLabel={t(`${tKey}DOCUMENT_TYPE`)}
                placeholder={t(`${tKey}DOCUMENT_TYPE`)}
                valueKey="id"
                labelKey="value"
                options={documentType}
                disabled={this.state.canBePrintedDisabled}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="dependentDocumentTypeUseId"
                controlLabel={t(`${tKey}DOCUMENT_USE_TYPE_DEPENDANT`)}
                placeholder={t(`${tKey}DOCUMENT_USE_TYPE_DEPENDANT`)}
                valueKey="id"
                labelKey="value"
                options={documentTypeUseCombo?.filter(x => x.id !== documentTypeUse?.documentTypeUseId)}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="canCreateEntity"
                placeholder={t(`${tKey}CAN_CREATE_ENTITY`)}
                colSm={0}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="onlyTemplateUpload"
                placeholder={t(`${tKey}ONLY_TEMPLATE_UPLOAD`)}
                onInputChange={(value) => this.handleOnlyTemplateUploadChange(value)}
                colSm={0}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="canBePrinted"
                placeholder={t(`${tKey}CAN_PRINT`)}
                disabled={documentTypeUse?.onlyTemplateUpload === true}
                colSm={0} />

              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="canBeAddedInHistorical"
                placeholder={t(`${tKey}CAN_ADDED_ARCHIVED_DOSSIER`)}
                colSm={0}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="canSendToProcessingAgency"
                placeholder={t(`${tKey}CAN_SEND_MANAGEMENT`)}
                colSm={0}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="massiveUploadAllowed"
                placeholder={t(`${tKey}ALLOW_BULK_UPLOAD`)}
                colSm={0}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="showInDocumentaryChecklist"
                placeholder={t(`${tKey}AVAILABLE_DOCUMENTARY_CHECKLIST`)}
                colSm={0}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="permissionViewId"
                controlLabel={t(`${tKey}AVAILABLE_VIEW`)}
                placeholder={t(`${tKey}AVAILABLE_VIEW`)}
                valueKey="id"
                labelKey="value"
                options={permissionCombo}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="permissionEditId"
                controlLabel={t(`${tKey}AVAILABLE_EDIT`)}
                placeholder={t(`${tKey}AVAILABLE_EDIT`)}
                valueKey="id"
                labelKey="value"
                options={permissionCombo}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="permissionId"
                controlLabel={t(`${tKey}AVAILABLE_VALIDATE`)}
                placeholder={t(`${tKey}AVAILABLE_VALIDATE`)}
                valueKey="id"
                labelKey="value"
                options={permissionCombo}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="permissionRejectId"
                controlLabel={t(`${tKey}AVAILABLE_REJECT`)}
                placeholder={t(`${tKey}AVAILABLE_REJECT`)}
                valueKey="id"
                labelKey="value"
                options={permissionCombo}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="permissionSignId"
                controlLabel={t(`${tKey}AVAILABLE_SIGN`)}
                placeholder={t(`${tKey}AVAILABLE_SIGN`)}
                valueKey="id"
                labelKey="value"
                options={permissionCombo}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="newVersionPermissionId"
                id="editDocumentTypeUse_newVersionPermissionId"
                controlLabel={t(`${tKey}NEW_VERSION_PERMISSION`)}
                placeholder={t(`${tKey}NEW_VERSION_PERMISSION`)}
                valueKey="id"
                labelKey="value"
                options={permissionCombo}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="functionToDoWhenCreate"
                controlLabel={t(`${tKey}FUNCTION_EXEC_CREATE`)}
                placeholder={t(`${tKey}FUNCTION_EXEC_CREATE`)}
                maxLength={50}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="functionToDoWhenUpdate"
                controlLabel={t(`${tKey}FUNCTION_EXEC_UPDATE`)}
                placeholder={t(`${tKey}FUNCTION_EXEC_UPDATE`)}
                maxLength={50}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="dependantFunctionToDoWhenCreate"
                controlLabel={t(`${tKey}FUNCTION_EXEC_DEPENDENT`)}
                placeholder={t(`${tKey}FUNCTION_EXEC_DEPENDENT`)}
                maxLength={50}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="metadataTemplateCode"
                controlLabel={t(`${tKey}FUNCTION_EXEC_EXTRACT_METADATA`)}
                placeholder={t(`${tKey}FUNCTION_EXEC_EXTRACT_METADATA`)}
                maxLength={50}
              />
            </div>
            <SimpleTablePage
              // customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={2}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-30' key={0}>
                  {t('MASTERS.NAME')}
                </th>,
                <th className='colWidth-55' key={1}>
                  {t('MASTERS.DESCRIPTION')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.name`}
                      placeholder={t('MASTERS.NAME')}
                      maxLength={50}
                    />
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editDocumentTypeUse',
  validate: (values, props) => {
    let error = {}
    if (values) {
      const tKey = 'MASTERS.DOCUMENT_TYPE_USE_MASTERS.VALIDATION.'
      if (!values.code) {
        error.code = props.t(`${tKey}CODE`)
      }
      if (!values.externalCode) {
        error.externalCode = props.t(`${tKey}EXTERNAL_CODE`)
      }
      if (!values.documentTypeId) {
        error.documentTypeId = props.t(`${tKey}DOCUMENT_TYPE`)
      }
      props.languageList && props.languageList?.forEach((element) => {
        let valueLangName = values['lang' + element.languageId].name
        let valueLangDesc = values['lang' + element.languageId].description
        let errorLang = {
          name: null,
          description: null
        }
        if (!valueLangName) {
          errorLang.name = props.t(`${tKey}NAME`)
        } else if (valueLangName.length > 50) {
          errorLang.name = props.t(`${tKey}NAME_LENGTH`)
        }
        if (!valueLangDesc || valueLangDesc.length > 50) {
          errorLang.description = props.t(`${tKey}DESCRIPTION`)
        } else if (valueLangDesc.length > 50) {
          errorLang.description = props.t(`${tKey}DESCRIPTION_LENGTH`)
        }
        error['lang' + element.languageId] = errorLang
      })
    }
    return Object.keys(error).length > 0 ? error : {}
  }
})(DocumentTypeUseMasterModal)
